import { LibraryBooks } from '@mui/icons-material';

import { PERMISSION_SALES_QUOTATION_ACCESS } from '../../constants/permissions.constant';

export const tooltipSalesQuotation = (t) => {
  return [
    {
      name: 'detail-sales-quotation',
      title: t('base.tooltip.detail'),
      permission: PERMISSION_SALES_QUOTATION_ACCESS,
    },
  ];
};

export const iconSalesQuotationList = [LibraryBooks];
